import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import PageNav from "../../ui/navigation/PageNav";
import { PROFILE_PAGES } from "./profilePages";

/**
 * The profile area (UX-29: one route each): the person's own pages (`PROFILE_PAGES`, F79), the
 * same as in the account menu. What the installation sets is in Administration (web-app.md WA-8).
 */
export default function ProfileLayout() {
  const { t } = useTranslation();
  return (
    <div className="app-main h-full space-y-5 p-6">
      <PageNav
        label={t("profile.pages.label")}
        pages={PROFILE_PAGES.map((page) => ({ path: page.path, label: t(`profile.pages.${page.id}`), end: page.end }))}
      />
      <Outlet />
    </div>
  );
}
